module.exports = __webpack_public_path__ + "media/customizations/royaloaks/logo-cd81a803ded23fe2c1e999287866a573.png";